export default __webpack_public_path__ + "static/media/Lora-Regular.5f3aa486.ttf";